import styled from 'styled-components';
import { Colors } from '../../ui';
import { DropButton } from '../../ui/DropButton';

const Base = styled.div<{ grow?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: ${p => p.grow ? '1 1 auto' : '0 0 auto'};
    gap: 1rem;
    padding: 1rem .25rem;

    ${DropButton} {
        padding: .25rem;
    }
`;

const Heading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .75rem;
    flex: 0 0 auto;
    color: ${Colors.primaryText};
    font-weight: 420;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    padding: 0 .75rem;
`;

export const AsidePanel = Object.assign(Base, {
    Heading,
    Content,
});
